export enum ITEM {
	LINK = 'link',
	MENU = 'menu',
}
type BaseItemType = {
	itemId: string;
	title: string;
	type: ITEM;
};
export interface LinkItemType extends BaseItemType {
	link: string;
	type: ITEM.LINK;
}
export interface MenuItemType extends BaseItemType {
	childItems?: ItemType[];
	type: ITEM.MENU;
}
export enum ALIGNMENT {
	LEFT = 'left',
	CENTER = 'center',
	RIGHT = 'right',
}
export enum BORDER {
	NONE = 'none',
	ALL_SIDES = 'all_sides',
	BOTTOM = 'bottom',
}
export enum CORNERS {
	ROUND = 'round',
	SHARP = 'sharp',
}
export type Styles = {
	alignment: ALIGNMENT;
	border: BORDER;
	borderColor: string;
	/**
	 * Per-menu corner radius (px) chosen via the config slider when the hub
	 * corner-radius feature is enabled. When unset, the menu inherits the hub-wide
	 * radius. Ignored when the feature is off.
	 */
	cornerRadius?: number;
	/**
	 * Legacy round/sharp corner toggle. Used when the hub corner-radius feature is
	 * off. When the feature is on, `cornerRadius` (a 0–32px value) takes precedence.
	 */
	cornerStyle: CORNERS;
	fillColor: string;
	highlightColor: string;
	textColor: string;
};
export type ItemType = MenuItemType | LinkItemType;
export type Items = ItemType[];
export type LinksMenuParameters = {
	extensionTitle?: string;
	handleClickAnalytics?: () => void;
	handleViewAnalytics?: () => void;
	items?: Items;
	styles: Styles;
	version: string;
};

export type ItemPositionalProps = {
	index: number;
	isFirst: boolean;
	isLast: boolean;
	level: number;
};
